// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEoyPlanReconciliationPlanDto
 */
export interface IEoyPlanReconciliationPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationPlanDto
     */
    plan_id: number;
    /**
     * 
     * @type {number}
     * @memberof IEoyPlanReconciliationPlanDto
     */
    amount: number;
}

/**
 * Check if a given object implements the IEoyPlanReconciliationPlanDto interface.
 */
export function instanceOfIEoyPlanReconciliationPlanDto(value: object): value is IEoyPlanReconciliationPlanDto {
    if (!('plan_id' in value) || value['plan_id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function IEoyPlanReconciliationPlanDtoFromJSON(json: any): IEoyPlanReconciliationPlanDto {
    return IEoyPlanReconciliationPlanDtoFromJSONTyped(json, false);
}

export function IEoyPlanReconciliationPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEoyPlanReconciliationPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'],
        'amount': json['amount'],
    };
}

export function IEoyPlanReconciliationPlanDtoToJSON(json: any): IEoyPlanReconciliationPlanDto {
    return IEoyPlanReconciliationPlanDtoToJSONTyped(json, false);
}

export function IEoyPlanReconciliationPlanDtoToJSONTyped(value?: IEoyPlanReconciliationPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'amount': value['amount'],
    };
}

